export const CANDIDATE_STATUS = {
  NEW: 'NEW',
  SHORTLISTED: 'SHORTLISTED',
  CONTACTED: 'CONTACTED',
  MATCHED: 'MATCHED',
  HIDDEN: 'HIDDEN',
  INVISIBLE: 'INVISIBLE',
} as const;

export enum CandidateHistoryAction {
  /** activity log */
  Unlocked = 'CAMPAIGN_CANDIDATE_UNLOCKED',
  Matched = 'CAMPAIGN_CANDIDATE_MATCHED',
  Hidden = 'CAMPAIGN_CANDIDATE_HIDDEN',
  Shortlisted = 'CAMPAIGN_CANDIDATE_SHORTLISTED',
  Invisible = 'CAMPAIGN_CANDIDATE_INVISIBLE',
  Contacted = 'CAMPAIGN_CANDIDATE_CONTACTED',
  MessageReceived = 'CAMPAIGN_CANDIDATE_MESSAGE_RECEIVED',
  SentToAts = 'CAMPAIGN_CANDIDATE_SENT_TO_ATS',
  LabelChanged = 'CAMPAIGN_CANDIDATE_LABEL_CHANGED',
  FollowUpPlanned = 'FOLLOW_UP_PLANNED',
  FollowUpSent = 'FOLLOW_UP_SENT',

  /** history */
  Note = 'CAMPAIGN_CANDIDATE_NOTE',
  EmailSent = 'CAMPAIGN_CANDIDATE_EMAIL_SENT',
  EmailReceived = 'CAMPAIGN_CANDIDATE_EMAIL_RECEIVED',
  InMailSent = 'CAMPAIGN_CANDIDATE_LINKEDIN_INMAIL_SENT',
  InMailReceived = 'CAMPAIGN_CANDIDATE_LINKEDIN_INMAIL_RECEIVED',
  LinkedinSent = 'CAMPAIGN_CANDIDATE_LINKEDIN_MESSAGES_SENT',
  LinkedinReceived = 'CAMPAIGN_CANDIDATE_LINKEDIN_MESSAGES_RECEIVED',
  IndeedSent = 'CAMPAIGN_CANDIDATE_INDEED_MESSAGES_SENT',
  IndeedReceived = 'CAMPAIGN_CANDIDATE_INDEED_MESSAGES_RECEIVED',

  /** ats actions */
  AtsNoteCreated = 'ATS_CANDIDATE_NOTE_CREATED',
  AtsStatusChanged = 'ATS_CANDIDATE_STATUS_CHANGED',
  AtsCandidateContact = 'ATS_CANDIDATE_CONTACT',

  /** rj communication hub actions */
  RJCommHubPipelineExpired = 'RJ_COMM_HUB_PIPELINE_EXPIRED',
  RJCommHubInitialMessageSent = 'RJ_COMM_HUB_INITIAL_MESSAGE_SENT',
  RJCommHubFollowUpPlanned = 'RJ_COMM_HUB_FOLLOW_UP_PLANNED',
  RJCommHubFollowUpSent = 'RJ_COMM_HUB_FOLLOW_UP_SENT',
  RJCommHubCandidateAccepted = 'RJ_COMM_HUB_CANDIDATE_ACCEPTED',
  RJCommHubCandidateRejected = 'RJ_COMM_HUB_CANDIDATE_REJECTED',
  CandidateAppliedRecommendation = 'CANDIDATE_APPLIED_RECOMMENDATION',
  CandidateAppliedRecommendationRejected = 'CANDIDATE_APPLIED_RECOMMENDATION_REJECTED',

  /** calendar actions */
  CalendarInterviewInvitationSent = 'CALENDAR_INTERVIEW_INVITATION_SENT',
  CalendarInterviewInvitationAccepted = 'CALENDAR_INTERVIEW_INVITATION_ACCEPTED',
  CalendarInterviewInvitationRescheduled = 'CALENDAR_INTERVIEW_INVITATION_RESCHEDULED',
  CalendarInterviewInvitationRejected = 'CALENDAR_INTERVIEW_INVITATION_REJECTED',
}

export type CandidateStatus = keyof typeof CANDIDATE_STATUS;

export const CANDIDATE_ACTION = {
  SHORTLIST: 'SHORTLIST',
  CONTACT: 'CONTACT',
  HIDE: 'HIDE',
  MATCH: 'MATCH',
  'SHOW-MORE': 'SHOW-MORE',
  ['SHARE-PROFILE']: 'SHARE-PROFILE',
  DOWNLOAD: 'DOWNLOAD',
} as const;

export const CANDIDATE_SECONDARY_ACTION = {
  MATCH: 'MATCH',
  'SHORTLIST-TO-ANOTHER-SEARCH': 'SHORTLIST-TO-ANOTHER-SEARCH',
  'RETRY-TO-SEND-TO-ATS': 'RETRY-TO-SEND-TO-ATS',
  ['SHARE-PROFILE']: 'SHARE-PROFILE',
  NOTE: 'NOTE',
  DOWNLOAD: 'DOWNLOAD',
  'SCHEDULE-INTERVIEW': 'SCHEDULE-INTERVIEW',
} as const;

export type CandidateAction = keyof typeof CANDIDATE_ACTION;
export type CandidateSecondaryAction = keyof typeof CANDIDATE_SECONDARY_ACTION;
